// User-level look & feel: accent colour and interface size. Stored locally,
// applied to <html>/<body> as soon as this module is imported.
const KEY = "boq.personalization";

export const ACCENTS = [
  { id: "teal", label: "Teal", color: "#14b8c4", hover: "#0e9aa5" },
  { id: "blue", label: "Blue", color: "#3b82f6", hover: "#2563eb" },
  { id: "violet", label: "Violet", color: "#8b5cf6", hover: "#7c3aed" },
  { id: "green", label: "Green", color: "#22c55e", hover: "#16a34a" },
  { id: "orange", label: "Orange", color: "#f97316", hover: "#ea580c" },
  { id: "rose", label: "Rose", color: "#f43f5e", hover: "#e11d48" },
];

export const SIZES = [
  { id: "s", label: "პატარა", zoom: 0.92 },
  { id: "m", label: "ნორმალური", zoom: 1 },
  { id: "l", label: "დიდი", zoom: 1.1 },
];

const DEFAULTS = { accent: "teal", size: "m" };

export function loadPersonalization() {
  try {
    return { ...DEFAULTS, ...(JSON.parse(window.localStorage.getItem(KEY) || "{}")) };
  } catch {
    return { ...DEFAULTS };
  }
}

export function applyPersonalization(p) {
  if (typeof document === "undefined") return;
  const accent = ACCENTS.find((a) => a.id === p.accent) || ACCENTS[0];
  const size = SIZES.find((s) => s.id === p.size) || SIZES[1];
  const root = document.documentElement;
  root.style.setProperty("--accent-primary", accent.color);
  root.style.setProperty("--accent-primary-hover", accent.hover);
  if (document.body) document.body.style.zoom = String(size.zoom);
}

export function savePersonalization(p) {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    /* ignore */
  }
  applyPersonalization(p);
}

if (typeof window !== "undefined") {
  const run = () => applyPersonalization(loadPersonalization());
  if (document.body) run();
  else window.addEventListener("DOMContentLoaded", run);
}
